import React from 'react'

import { Portlet, Row, Col, Button, Form } from '_zari/core'

import { ZariContext } from '_zari/context'

import * as CompraCrud from 'services/compra.service'

import { MesContabilidadSelect, SelectSede } from 'sharedComponents/select'

import { DownloadAxiosFile } from 'utils'

const FormatoCruceComprasKardex = () => {
  const __zariContext = React.useContext(ZariContext)

  const [mesSeleccionado, setMesSeleccionado] = React.useState()
  const [sedeSeleccionada, setSedeSeleccionada] = React.useState([])
  const [resultados, setResultados] = React.useState(null)
  const [buscando, setBuscando] = React.useState(false)

  const getParams = () => ({ mesSeleccionado, sedeSeleccionada })

  const clickDescargarFormatoCruceComprasKardex = React.useCallback(() => {
    __zariContext.loader.open('Descargando Reporte Cruce Compras Kardex...')
    CompraCrud.descargarFormatoCruceComprasKardex(getParams())
      .then(({ data, headers }) => { DownloadAxiosFile.downloadAsBlob(data, headers) })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => { __zariContext.loader.close() })
  }, [mesSeleccionado, sedeSeleccionada, __zariContext])

  const clickBuscar = React.useCallback(() => {
    setBuscando(true)
    CompraCrud.consultaCruceComprasKardex(getParams())
      .then(({ data }) => setResultados(data))
      .catch(({ data }) => __zariContext.snack('error', data?.error || 'Error al consultar'))
      .finally(() => setBuscando(false))
  }, [mesSeleccionado, sedeSeleccionada, __zariContext])

  return (
    <Portlet>
      <Portlet.Header title='Reporte Cruce Compras - Kardex' />
      <Portlet.Body>
        <Row>
          <Col md={12}>
            <Form.Group>
              <Form.Label text='MES' htmlFor='select-mes' md={2} alignRightAt='md' />
              <Col md={10}>
                <MesContabilidadSelect name='select-mesContabilidad-cruce' id='select-mesContabilidad-cruce' value={mesSeleccionado} onChange={e => setMesSeleccionado(e.target.value)} />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Form.Group>
              <Form.Label text='ESTABLECIMIENTO' htmlFor='select-sede-cruce' md={2} alignRightAt='md' />
              <Col md={10}>
                <SelectSede name='select-sede-cruce' id='select-sede-cruce' value={sedeSeleccionada} onChange={e => setSedeSeleccionada(e.target.value)} />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={12} className='text-right'>
            <Button variant='outline-primary' onClick={clickBuscar} disabled={buscando} className='mr-2'>
              {buscando ? 'Buscando...' : 'Buscar'}
            </Button>
            <Button onClick={clickDescargarFormatoCruceComprasKardex}>Descargar Reporte</Button>
          </Col>
        </Row>

        {resultados && (
          <Row className='mt-3'>
            <Col md={12}>
              <div style={{ maxHeight: 500, overflowY: 'auto' }}>
                <table className='table table-sm table-striped table-bordered'>
                  <thead>
                    <tr>
                      <th>FECHA</th>
                      <th>T.DOC</th>
                      <th>SERIE</th>
                      <th>NUMERO</th>
                      <th>COD. COMPRA</th>
                      <th>PRODUCTO</th>
                      <th className='text-right'>CANT. COMPRA</th>
                      <th>COD. KARDEX</th>
                      <th className='text-right'>CANT. KARDEX</th>
                      <th>ESTADO</th>
                    </tr>
                  </thead>
                  <tbody>
                    {resultados.map((r, i) => (
                      <tr key={i} style={r.error ? { backgroundColor: '#ffe0e0' } : {}}>
                        <td>{r.fecha}</td>
                        <td>{r.tipoDocumento}</td>
                        <td>{r.serie}</td>
                        <td>{r.numero}</td>
                        <td>{r.codigoCompra}</td>
                        <td>{r.productoCompra}</td>
                        <td className='text-right'>{r.cantidadCompra}</td>
                        <td>{r.codigoKardex}</td>
                        <td className='text-right'>{r.cantidadKardex}</td>
                        <td>{r.error ? 'ERROR' : 'OK'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <small className='text-muted'>{resultados.length} registros encontrados</small>
            </Col>
          </Row>
        )}
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(FormatoCruceComprasKardex)
